import { getCookie } from "../../react/utils/cookies";
import runAfterPageLoad from "../runAfterPageLoad";

export default function modifyRegistrationFields() {
  runAfterPageLoad(() => {
    const items = document.getElementsByClassName("registration_field_item");
    if (items.length < 1) return;

    Array.from(items).forEach((item) => {
      $(item)
        .find("td")[1]
        .addEventListener("change", () => setRequiredCheckbox(item));
      $(item)
        .find("td")[2]
        .addEventListener("change", () => updateField(item));
      $(item)
        .find("td")[3]
        .addEventListener("change", () => setVisibleCheckbox(item));
    });
  });
}

function updateField(item) {
  const id = $(item).find("td :input")[1].getAttribute("data-field-id");
  const name = $(item).find("td")[0].innerText;
  if (!name) return;

  const itemValues = getValues(item);
  let params = {};

  const url = `/registration_fields/${id}`;
  params = {
    user_attribute_options: {
      required: itemValues.required,
      visible_for_user_profile: itemValues.visibleForProfile,
      visible_for_registration: itemValues.visibleForRegistration,
    },
  };

  $.ajax({
    url: url,
    method: "PUT",
    headers: {
      AuthorizationUserToken: getCookie("user_token") ?? null,
    },
    contentType: "application/json",
    data: JSON.stringify(params),
    error: function () {
      alert("Error occured while trying to update field");
    },
  });
}

function setVisibleCheckbox(item) {
  const itemValues = getValues(item);

  if (itemValues.required == true && itemValues.visibleForRegistration == false)
    $(item).find("td :input")[0].checked = true;

  updateField(item);
}

function setRequiredCheckbox(item) {
  const itemValues = getValues(item);
  if (itemValues.visibleForRegistration == false && itemValues.required == true) {
    $(item).find("td :input")[0].checked = true;
    $(item).find("td :input")[2].checked = true;
  }

  updateField(item);
}

function getValues(item) {
  return {
    visibleForRegistration: $(item).find("td :input")[0].checked,
    visibleForProfile: $(item).find("td :input")[1].checked,
    required: $(item).find("td :input")[2].checked,
  };
}
